<template>
  <div class="">
    <div class="row row-flex mt-3 mb-3">
      <div class="col-md-8">
        <div v-if="rights.rapport.synthese_resume && affiche_pano" id="pano" style="width:100%;height:350px"></div>
        <iframe v-if="rights.rapport.synthese_carte" :src="'https://www.google.com/maps/embed/v1/place?key='+gmapkey+'&q='+encodeURIComponent(value.adresse+' '+value.ville+' '+value.code_postal)" width="100%" height="350" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
      </div>
      <div class="col-md-4 bg-blue p-3 bigText2 pl-5 pr-5">
        <h3 class="bold">{{$t("Récapitulatif")}}</h3>
        <ul class="nolist bigspace">
          <li><b class="color-white">{{$t("Référence")}} : </b> <b>{{value.reference}}</b></li>
          <li><b class="color-white">{{$t("Date de l'estimation")}} : </b> <b>{{value.dateF}}</b></li>
          <li><b class="color-white">{{$t("Evaluation Ooftop")}} : </b> <b class="hight">{{$t("$")}} {{format_number(value.estimation)}} {{$t("€")}}</b></li>
          <li><b class="color-white">{{$t("Prix estimé au m²")}} : </b> {{$t("$")}} {{format_number(value.estimation_m2)}} {{$t("€")}}</li>
          <li><b class="color-white">{{$t("Indice de confiance")}} : </b> <Gauge :value="value.indice"/></li>
          <li v-if="rights.rapport.synthese_no_marche_immo != true"><b class="color-white">{{$t("Liquidité du bien")}} : </b> {{$t((!value.liquidite)?"Faible":((value.liquidite==1)?"Courante":"Forte"))}}</li>
          <li><b class="color-white">{{$t("Type de bien")}} :</b> {{ $t(value.type_bien) }}</li>
          <li><b class="color-white">{{$t("Surface")}} : </b> {{format_number(value.surface)}} m²</li>
          <li v-if="parseInt(value.montant_acquisition) > 0" style="font-style:italic; font-size:9px;">La surface a été estimée à partir d’un montant d’acquisition de {{$t("$")}} {{ value.montant_acquisition }} {{$t("€")}} ({{value.date_acquisition}})</li>
          <li v-if="value.nb_pieces.total!='' && value.nb_pieces.total>0"><b class="color-white">{{$t("Nombre de pièces")}} :</b> {{ value.nb_pieces.total }}</li>
        </ul>
        <br/>
        <button v-if="captureImg && rights.see_capture_streetview" @click="capture_image()" class="btn btn-primary btn-xs text-left" :disabled="disable_capture">{{$t("Capturer l'image")}}</button>
        <button v-if="value.indice<seuilAna" @click="show_convert_expert()" class="btn btn-gold btn-xs text-left" style="padding:5px 10px 5px 5px"><i class="icon-accuracy mr-2"></i> {{$t("Demander l'avis à un expert")}} <b-spinner class="align-middle" v-if="convert_expert_ec"></b-spinner></button>
      </div>
    </div>
    <b-modal id="modal-convert-expert" title="Information" hide-footer>
      <p class="my-4">{{$t("L’indice de confiance de l'évaluation indique qu’il est nécessaire qu’un évaluateur évalue ce bien.\n\nVoulez vous demander un avis d’évaluateur ?")}}</p>
      <p>
        <b-button class="btn-secondary mr-3" type="button" @click="close_convert_expert">{{$t("Non")}}</b-button>
        <b-button class="btn-gold" type="button" @click="run_convert_expert">{{$t("Oui")}}</b-button>
      </p>
      <b-form-group label="Je souhaite recevoir un email de confirmation de commande" label-for="partner_demande_email" class="light redFirst">
        <b-form-radio-group buttons v-model="demande_email" name="partner_demande_email" :options="this.yesno"></b-form-radio-group>
      </b-form-group>
      <b-form-group label="Je souhaite recevoir une email pour m’avertir de la publication du rapport et de la facture" label-for="partner_rapport_email" class="light redFirst">
        <b-form-radio-group buttons v-model="rapport_email" name="partner_rapport_email" :options="this.yesno"></b-form-radio-group>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Gauge from '@/components/Gauge'
export default {
  name: 'EvaluationStreetview',
  components: {Gauge},
  data() {
    return {
      nodata:this.$i18n.t('Données insuffisantes'),
      captureImg:false,
      convert_expert_ec: false,
      demande_email:0,
      rapport_email:0,
      yesno:[
        {value:"0",text:this.$i18n.t("Non")},
        {value:"1",text:this.$i18n.t("Oui")}
      ],
      disable_capture:false,
      affiche_pano:0,
    }
  },
  props:{
    value: Object,
    gmapkey: String,
    rights: Object,
    seuilAna : Number
  },
  watch: {
  },
  computed: {
  },
  methods: {
    capture_image(){
      var p=this;
      if(!p.disable_capture){
        p.disable_capture=true;
        axios.get(this.$apiUrl+"demandes/streetview/"+p.value.id+"?lang="+this.$i18n.locale+"&sv="+JSON.stringify(p.value.streetview)+"&auth="+JSON.stringify(this.auth_header())).then(response => {
          p.$emit('enregSuccess',p.$i18n.t("Image enregistrée"));
          p.value.hasRapport=false;
          p.disable_capture=false;
          axios.get(p.$apiUrl+"demandes/rapport/"+p.value.id+"?lang="+p.$i18n.locale+"&generate=1&auth="+JSON.stringify(p.auth_header())).then(response => {p.value.hasRapport=true;})
        })
      }
    },
    load_pano(){
      var p=this;
      var posEtr = new google.maps.LatLng(p.value.streetview.lat,p.value.streetview.lng);
      var panoramaOptions = {
        pano:posEtr,
        pov: {
          heading: p.value.streetview.heading,
          pitch:p.value.streetview.pitch,
          zoom:p.value.zoom
        },
        source: google.maps.StreetViewSource.OUTDOOR
      };
      var streetViewService = new google.maps.StreetViewService();
      var panoRequest = {
          location: posEtr,
          preference: google.maps.StreetViewPreference.NEAREST,
          radius: 50,
          source: google.maps.StreetViewSource.OUTDOOR
      };
      streetViewService.getPanorama(panoRequest, function(panoData, status){
          if (status === google.maps.StreetViewStatus.OK) {
            panoramaOptions.pano=panoData.location.pano;//Voir si ca pose pas de pb pour screen l'image
            p.value.streetview.pano=panoData.location.pano;
            var panorama = new google.maps.StreetViewPanorama(document.getElementById("pano"), panoramaOptions);
            panorama.setVisible(true);
            panorama.addListener("position_changed", () => {
              var positionTab=panorama.getPosition()
              if(positionTab && typeof positionTab !== 'object'){
                  positionTab=positionTab.replace('(','').replace(')','').split(',');
                  p.value.streetview.lat=positionTab[0];
                  p.value.streetview.lng=positionTab[1];
              }
              p.captureImg=true;
            });
            panorama.addListener("pov_changed", () => {
              p.value.streetview.heading=panorama.getPov().heading;
              p.value.streetview.pitch=panorama.getPov().pitch;
              p.captureImg=true;
            });
            panorama.addListener("pano_changed", () => {
              p.value.streetview.pano = panorama.getPano();
            });
          } else {
            var mapOptions = {
              zoom: p.value.streetview.zoom,
              center: posEtr,
              mapTypeId: 'satellite'
            };
            var panorama = new google.maps.Map(document.getElementById('pano'),mapOptions);
            panorama.addListener("center_changed", () => {
              var center = panorama.getCenter();
              p.value.streetview.lat = center.lat();
              p.value.streetview.lng = center.lng();
              p.captureImg=true;
            });
            panorama.addListener("zoom_changed", () => {
              p.value.streetview.zoom=panorama.getZoom();
              p.captureImg=true;
            });


          }
      });
    },
    show_convert_expert(){
      this.$bvModal.show("modal-convert-expert");
    },
    run_convert_expert(){
      this.$bvModal.msgBoxConfirm(this.$i18n.t("Commande en cours ..."));
      this.convert_expert_ec=1;
      this.convert_expert(this.value.id,demande_email,rapport_email);
    },
    close_convert_expert(){
      this.$bvModal.hide('modal-convert-expert');
    },
    format_date_trans(date){
      if(this.$i18n.locale=='fr')return date;
      date=date.split(' ');
      date[0]=this.$i18n.t(date[0]);
      return date.join(' ');
    },
  },
  mounted(){
    var p=this;
    window.setTimeout(function(){
      p.affiche_pano=1;
      p.load_pano();
    },2000);
    if(!this.value.hasRapport && this.value.indice<this.seuilAna){            
      this.show_convert_expert();
    }
  }
}
</script>